module.exports = __webpack_public_path__ + "static/img/299tupian.88e24c16.png";